module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('div', [_c('div', {
    attrs: {
      "id": "selectedOffersInnerDiv"
    }
  }, [_c('div', {
    staticClass: "scrollWrapper",
    style: ({
      width: ("" + _vm.scrollableWidth)
    }),
    attrs: {
      "id": "changesApproveScrollWrapper"
    },
    on: {
      "scroll": function($event) {
        _vm.topScroll($event)
      }
    }
  }, [_c('div', {
    staticClass: "simulateScrollDiv",
    style: ({
      width: ((_vm.scrollableChildrenWidth * _vm.information.length) + "rem")
    }),
    attrs: {
      "id": "simScrollbar"
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "inline-block",
    attrs: {
      "id": "selectedOffersHeaderContainer"
    }
  }, [_c('data-table', {
    attrs: {
      "data": _vm.headers,
      "styles": _vm.tableStyles.offersListHeaderStyles
    }
  })], 1), _vm._v(" "), _c('div', {
    staticClass: "inline-block scrollable",
    style: ({
      width: _vm.scrollableWidth
    }),
    attrs: {
      "id": "selectedOffersDataContainer"
    },
    on: {
      "scroll": function($event) {
        _vm.bottomScroll($event)
      }
    }
  }, [_c('div', {
    staticClass: "inline-block",
    style: ({
      width: ((_vm.information.length * _vm.scrollableChildrenWidth) + "rem")
    })
  }, _vm._l((_vm.information), function(data) {
    return _c('div', {
      staticClass: "inline-block",
      style: ({
        width: (_vm.scrollableChildrenWidth + "rem")
      })
    }, [_c('data-table', {
      attrs: {
        "handleEvent": _vm.childEvent,
        "data": data,
        "stringPadding": _vm.detailedDataPadding,
        "styles": _vm.tableStyles.offersListDataStyle,
        "functions": _vm.childEvent
      }
    })], 1)
  }))])]), _vm._v(" "), _c('div', {
    staticClass: "width_full",
    style: (_vm.mainContainerStyle.mainStyle.tableButton)
  }, [_c('button', {
    class: {
      'primary-green-bg': _vm.hasChanges, 'light-grey-text': !_vm.hasChanges, 'width_half': true
    },
    attrs: {
      "type": "button",
      "disabled": !_vm.hasChanges
    },
    on: {
      "click": _vm.submitApproveLock
    }
  }, [_vm._v("\n        Approve with changes and lock offer\n      ")])])])])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-cccf0740!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/pop-up/ApproveWithChanges.vue
// module id = 382
// module chunks = 2